<template>
    <div class="customer-list">
        <CustomerListElement v-for="customer in customers" :key="`cli-${customer.id}`"
            @click="elementClicked(customer.id)"
            @button-clicked="listElementClicked(customer.id)" style="cursor:pointer"
            :customer="customer"
            :filtered="filtered"
            :mode="mode"
            :party="party"
            :show-sales-volume="showSalesVolume"
            :selectable="selectable"
            :selected="selectable && selectedIds.includes(customer.id)"
        />
    </div>
</template>

<script>
import CustomerListElement from "./elements/CustomerListElement";

export default {
    name: "CustomerList",
    components: { CustomerListElement },
    props: {
        customers: { type: Array, required: false },
        filtered: { type: String, default:'' },
        party: null,
        selectable: Boolean,
        selectedIds: { type: Array, default: () => [] },
        mode: { type:String, default:'list'},
        showSalesVolume: Boolean,
    },
    emits: ['customer-clicked', 'customer-element-clicked'],
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        listElementClicked(custId){
           this.$emit('customer-clicked',custId)
        },
        elementClicked(custId){
            this.$emit('customer-element-clicked',custId)
        }

    }

}
</script>
